import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, FormGroupDirective } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';

import { LoaderService } from '@teem/core/services/loader.service';
import { ClientService } from '@teem/core/services/client.service';
import { messages as i18n } from '@teem/core/constants/messages';

@Component({
	selector: 'app-import-client-modal',
	templateUrl: './import-client-modal.component.html',
	styles: []
})

export class ImportClientModalComponent implements OnInit {

	@ViewChild('newClientForm') newClientForm: FormGroupDirective;
	clientForm: FormGroup;
	submitted: boolean = false;
	uploadedFile: any;
	formData = new FormData();

	pondOptions = {
		multiple: false,
		allowReplace: false,
		allowRemove: true,
		allowImageResize: true,
		allowImagePreview: true,
		imageResizeMode: 'cover',
		acceptedFileTypes: "application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.oasis.opendocument.spreadsheet",
		labelIdle: `<span class="icon-upload"></span>`
	};

	constructor(
		private fb: FormBuilder,
		private clientService: ClientService,
		private loaderService: LoaderService,
		public activeModal: NgbActiveModal,
		private el: ElementRef) {
	}

	ngOnInit(): void {
		this.clientForm = this.fb.group({});
	}

	onFileChange(event) {
		if (event.target.files.length > 0) {
			this.uploadedFile = event.target.files[0];
		}
	}

	removeFile() {
		this.uploadedFile = null;
	}

	pondHandleInit() {
		// console.log('FilePond has initialised', this.myPond);
	}

	pondHandleAddFile(event: any) {
		if (this.formData.has('uploaded_file')) {
			this.formData.set('uploaded_file', event.file.file);
		} else {
			this.formData.append('uploaded_file', event.file.file);
		}
	}

	downloadTemplate() {
		window.location.href = '/clients/download?format=template';
	}

	submit() {
		if (!this.formData.has('uploaded_file')) {
			Swal.fire(i18n.alert.error, i18n.error.record_not_found, 'error');
		} else if (this.clientForm.valid) {
			this.loaderService.startLoading();

			let fd: any = this.clientForm.value;
			if (this.formData.has('uploaded_file')) {
				fd.uploaded_file = this.formData.get('uploaded_file');
			}

			this.clientService.importFile(fd, { headers: { 'Content-Type': 'multipart/form-data' } }).subscribe(data => {
				this.loaderService.stopLoading();

				this.clientForm.reset();
				this.activeModal.close(data);

				Swal.fire(i18n.done, 'Clients are imported', 'success');
				this.submitted = false;
			}, err => {
				this.loaderService.stopLoading();
				// Set server side error
				if (err.status === 422) {
					if (err.error && err.error.errors && Object.keys(err.error.errors).length) {
						let validationErrors = err.error.errors;
						Object.keys(validationErrors).forEach((prop) => {
							this.clientForm.get(prop)?.setErrors({
								serverError: validationErrors[prop]
							})
						})
					}
				}
				Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
			});
		}
	}
}
